import { produce } from 'immer';
import _ from 'lodash';

import { RESET_STATE } from 'store/global/actions';

import { TASKS_ACTION_TYPE } from '../actions';

const initialState = {};

const tasksReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case TASKS_ACTION_TYPE.GET_TASKS_BY_LOAN_ID:
        return payload || initialState;

      case TASKS_ACTION_TYPE.ADD_TASK:
      case TASKS_ACTION_TYPE.APPROVE_TASK:
        draft[payload.taskId] = payload;
        break;

      case TASKS_ACTION_TYPE.EDIT_TASK:
        draft[payload.taskId] = meta?.withPartialData
          ? { ...draft[payload.taskId], ...payload }
          : payload;
        break;

      case TASKS_ACTION_TYPE.REJECT_TASK:
        return { ...state, ...payload };

      case TASKS_ACTION_TYPE.DELETE_TASKS:
        return _.omit(state, payload.taskIds);

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default tasksReducer;
